export default function MaintenancePage() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="max-w-md mx-auto px-4 text-center">
        {/* Logo/Icon */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-orange-500 rounded-full">
            <svg
              className="w-10 h-10 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4v2m0 4v2M6.172 6.172a4 4 0 015.656 0l2.828 2.828a4 4 0 010 5.656l-2.828 2.828a4 4 0 01-5.656 0M9 9h.01M15 9h.01M9 15h.01M15 15h.01"
              />
            </svg>
          </div>
        </div>

        {/* Content */}
        <h1 className="text-4xl font-bold text-white mb-4">Maintenance</h1>
        <p className="text-lg text-slate-300 mb-6">
          We&#39;re currently performing maintenance on our system.
        </p>
        <p className="text-slate-400 mb-8">
          We&#39;ll be back online shortly. Thank you for your patience.
        </p>

        {/* Dots Animation */}
        <div className="flex justify-center gap-2 mb-8">
          <div
            className="w-2 h-2 bg-orange-500 rounded-full animate-bounce"
            style={{ animationDelay: '0s' }}
          ></div>
          <div
            className="w-2 h-2 bg-orange-500 rounded-full animate-bounce"
            style={{ animationDelay: '0.2s' }}
          ></div>
          <div
            className="w-2 h-2 bg-orange-500 rounded-full animate-bounce"
            style={{ animationDelay: '0.4s' }}
          ></div>
        </div>

        {/* Contact/Info */}
        <div className="text-sm text-slate-500 space-y-2">
          <p>For more information, please contact support.</p>
          <p>Thank you for your understanding.</p>
        </div>
      </div>
    </div>
  );
}
